import { EventEmitter, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, filter } from "rxjs/operators";

interface BroadcastEvent {
  eventName: string;
  data?: any;
}

@Injectable()
export class BrokerService {
  private eventEmitter: EventEmitter<BroadcastEvent>;
  private bus: Observable<BroadcastEvent>;

  constructor() {
    this.eventEmitter = new EventEmitter<BroadcastEvent>();
    this.bus = this.eventEmitter.asObservable();
  }

  public broadcast(eventName: string, data?: any) {
    // console.log("broadcast", eventName, data);
    this.eventEmitter.emit({ eventName, data });
  }

  public on<T>(eventName: string): Observable<T> {
    // console.log("on", eventName);
    return this.bus.pipe(
      filter((event) => event.eventName === eventName),
      map((event) => event.data as T)
    );
  }
}
